import ZeroTimeTool from '../class/ZeroTool';

export default class ZeroTimeUtils {
  //取得零時秒數
  static getZerotimeSeconds() {
    if (
      localStorage.getItem('ZerotimeSeconds') === null ||
      localStorage.getItem('ZerotimeSeconds') === ''
    ) {
      localStorage.setItem('ZerotimeSeconds', 0);

      return 0;
    } else {
      return parseFloat(localStorage.getItem('ZerotimeSeconds'));
    }
  }

  //取得拖拉區零時長度
  static getZerotimeWidth() {
    //一秒 40px
    return ZeroTimeUtils.getZerotimeSeconds() * 40;
  }

  //顯示時間
  static TimeDisplayRef_Text(player_currentTime, totalPlayTime) {
    let zeroTimeTool = new ZeroTimeTool(0, player_currentTime);

    return zeroTimeTool.getTimeDisplayRef_Text(totalPlayTime);
  }

  //要撥放影片 需要處理 zero time
  static getPlayerRightTime(DataObjSeconds) {
    let zeroTimeTool = new ZeroTimeTool(DataObjSeconds, 0);

    return zeroTimeTool.getPlayerRightTime();
  }

  //要從影片的時間 轉換成DataObj秒數
  static convertPlayerTimeToDataObjSeconds(playerSeconds) {
    let zeroTimeTool = new ZeroTimeTool(0, playerSeconds);

    //資料秒數扣掉 Zero time
    return zeroTimeTool.convertPlayerTimeToDataObjSeconds();
  }
}



// WEBPACK FOOTER //
// ./src/helper/ZeroTimeUtils.js